import * as type from '../../types';


// Action creator to request subscription creation
export const createSubscriptionRequest = (payload)=>({
    type:type.SUBSCRIPTION_CREATE_REQUEST,
    payload
})
// Action creator for successful subscription creation
export const createSubscriptionSuccess = (response) => ({
    type: type.SUBSCRIPTION_CREATE_SUCCESS,
    response,  // 'response' should match what you return in the saga
})
// Action creator for failed subscription creation
export const createSubscriptionFailure = (error) => ({
    type: type.SUBSCRIPTION_CREATE_FAILURE,
    error,  // 'error' should match what you return in the saga
})


// Fetch action
export const fetchSubscriptionsRequest = () => ({
    type: type.SUBSCRIPTIONS_FETCH_REQUEST,
});

export const fetchSubscriptionsSuccess = (subscriptions) => ({
    type: type.SUBSCRIPTIONS_FETCH_SUCCESS,
    subscriptions,  // Pass the fetched list of subscriptions
});

export const fetchSubscriptionsFailure = (error) => ({
    type: type.SUBSCRIPTIONS_FETCH_FAILURE,
    error,  // Pass the error in case of failure
});



///Update action 
export const updateSubscriptionRequest = (id, payload) => ({
    type: type.SUBSCRIPTION_UPDATE_REQUEST,
    id,
    payload,
});


// Action creator for successful subscription update
export const updateSubscriptionSuccess = (response) => ({
    type: type.SUBSCRIPTION_UPDATE_SUCCESS,
    response,
});

// Action creator for failed subscription update
export const updateSubscriptionFailure = (error) => ({
    type: type.SUBSCRIPTION_UPDATE_FAILURE,
    error,
});